import Component from 'vue-class-component';
import moduleStore from './store/withDrawIndex';
import Vue from 'vue';
import PageState from './store/state';
import DrawRing from './components/drawRing/drawRing.vue';
import {getQueryString} from "@/utils/location";
import { toast } from '@/utils/util';
import { VIP_TYPE } from '@/constants/vip'
import { Dialog } from "vant"

/**components**/
@Component({
  components: {
    DrawRing,
  },
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class withDrawIndexPage extends Vue {
  state = new PageState();
  self: Vue = this;
  percentage = 10;
  moneyObj = {
    total: 0,
    canWithdrawCash: 0,
    withdrawOutCash: 0,
  };
  list = [];
//   busy = true;
  showWithdrawModal = false;//展示提现表单
  currentItem:any = {};
  withdrawalInfo: any = {
    num: '', //提现金额
  };
  active = '';
  directives: { infiniteScroll };
  bankCardInfo = {id:'',bankName:'',bankCardNo:''};
  showBankList=false;
  bankCardListPicker=[];
  showPopover=true;
  txgToken ='';
  vipPermission=0;
  isMinip = false;
  MoyinAppVip: any = (<any>window).MoyinAppVip;
  MoyinAppTxgOrder:any = (<any>window).MoyinAppTxgOrder;
  type=0;//任务类型
  get operability() {
    return new Date().getTime()>this.currentItem.balanceDateMillis;
  }
  created(moduleData: IinjectDatas) {
    this.state = <PageState>moduleData.state;
    console.log('----index',this.state)
  }
  mounted(moduleData: IinjectDatas) {
    document.title = '提现';
    this.state.self = this;
    let ww_token = getQueryString("ww_token");
    this.txgToken = getQueryString("txgToken");
    if (ww_token) {
        this.state.ww_token = ww_token;
        this.getVipInfoFn();
        this.getWithdrawInfo();//获取金额信息
        this.getWithdrawList();
        this.getRecentBankCard();
        this.getAllBankCardList();
    }
    //区分小程序和app
    let ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('micromessenger')!=-1 || ua.indexOf('miniProgram')!=-1||ua.indexOf('toutiao')!=-1) {
      //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
     this.isMinip = true;
    }
  }
  getVipInfoFn(){
    let vm = this;
    this.$http("getVipInfo").then(res=>{
      if (res.code == 200) {
			  vm.vipPermission = res.data.type;
			}
    })
  }
  getWithdrawInfo() {
    this.$http('withdrawInfo',{ww_token:this.state.ww_token})
      .then(res => {
        if (res.code == 200) {
          this.moneyObj = {...res.data};
        }
      })
      .catch(res => {
        console.log('获取金额失败', res);
      });
  }
  getWithdrawList() {
    //滚动已测试
    this.$http('withdrawList').then(res=>{
    	if (res.code == 200) {
        this.list= res.data;
    	}else{
            toast(res.message||'获取列表失败，请稍后再试', 'top')
        }
    })
}
  showModal(item) {
    if (this.vipPermission != VIP_TYPE.SVIP && this.vipPermission != VIP_TYPE.COMPANY) {
      Dialog.confirm({
        title: '温馨提示',
        message: '成为魔音工坊会员后可提现',
        confirmButtonColor: '#3583fb',
        confirmButtonText: '成为会员',
        cancelButtonColor: '#EBEBEB',
        cancelButtonText: '取消',
        className: 'blue-dialog',
      }).then(() => {
            // on confirm-跳转购买会员界面
            if(this.isMinip) {
                 //小程序跳转
                 this.$navigateTo({
                    url: `/pages/recharge-vip/recharge-vip?fromBtn=withDrawIndex`,
                });
            }else{
                console.log('---准备跳转app的to会员')
               this.MoyinAppVip.postMessage("");
            }
        })
        .catch(() => {
          // on cancel
          console.log('---取消');
        });
      return;
    }
    this.showWithdrawModal = true;
    this.currentItem = {...item};
    this.withdrawalInfo.appletId = item.appletId;
  }
  changeStatus(activeName) {
    this.active = activeName;
  }
  toAddBankCard(){
    this.$router.push({path: '/bankCardList',query: {
        ww_token: this.state.ww_token
    }})
  }
  getRecentBankCard(){
    this.$http('getBankCardRecent').then(res=>{
        if(res.code==200){
            this.bankCardInfo = {...res.data};
        }else{
            toast('获取银行卡失败，请稍后再试', 'top')
        }
    })
  }
  getAllBankCardList(){
    let searchparam ={page:1,pageSize:20}
    this.$http('getBankCardList',searchparam).then(res=>{
        if(res.code==200){
            this.bankCardListPicker =res.data.results.map(obj => ({ text: obj.bankName+" "+obj.bankCardNo,value:obj.id }));
        }else{
            toast('获取银行卡列表失败，请稍后再试', 'top')
        }
    })
  }
  onConfirm(selectedOptions){
    this.showBankList = false;
    this.bankCardInfo = {id:selectedOptions.value,bankName:selectedOptions.text.split(" ")[0],bankCardNo:selectedOptions.text.split(" ")[1]};
  }
  forCash(){
    let params = {appletId:this.withdrawalInfo.appletId,bankCardId:this.bankCardInfo.id,dataType:this.currentItem.dataType};
    this.$http('getCash',{body:params}).then(res=>{
        if(res.code==200){
          this.$toast({
            message: res.data||'提现申请提交成功，请耐心等待~',
            icon: 'none',
            duration: 5000
          })
          this.getWithdrawInfo();//获取金额信息
          this.getWithdrawList();
        }else if(res.code ==500){
          this.$toast({
            message: '请求失败，请稍后重试',
            icon: 'fail',
            duration: 5000
          })
        }else{
          this.$toast({
            message: res.message||'请求失败，请稍后重试',
            icon: 'fail',
            duration: 5000
          })
        }
        //关闭弹窗
        this.showWithdrawModal = false;
        this.currentItem = {};
        this.withdrawalInfo = {
          num: ''
        };
    })
  }
  toWithDrawalList(){
    this.$router.push({path:'/withDrawalList',query: {
        ww_token: this.state.ww_token
    }})
  }
  toShangdan(){
    if(this.isMinip){
        let jumpUrl = '';
        jumpUrl = `https://xgsj.lizhibj.cn/channel/pageData/home/concise_home?token=${this.txgToken}`;
        this.$navigateTo({url: `/pages/webview/webview?from=txg&url=${encodeURIComponent(jumpUrl)}`});
    }else{
        this.MoyinAppTxgOrder.postMessage("");
    }
  }
  showStatusToast(item){
    item.showPopover = !item.showPopover;
  }
}
